import React from "react"
import { poster } from "../../images"
import "../../App.css"

export default class Home extends React.Component {
  render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={poster} alt="flashpass-poster" />
        </header>
      </div>
    )
  }
}
